import { SitecoreGenericFieldInterface } from './ContactInfo.types';
import { regExpFromSitecorePattern } from '../../lib/utils/contactForm';

export type ContactInfoEmailRulesContext = {
  getValues: (name?: string) => unknown;
};

/**
 * Validation for {@link ContactInfoEmailFormInput} only: required + Sitecore regex when present.
 * Zip/state rules from the generic textbox path do not apply to `Email`.
 */
export function buildContactInfoEmailRules(
  formElements: SitecoreGenericFieldInterface,
  ctx: ContactInfoEmailRulesContext
) {
  const { getValues } = ctx;

  return {
    required: formElements?.isRequired?.value ? formElements?.requiredFieldMessage?.value : ``,
    validate: async () => {
      if (formElements?.regex && formElements?.regex?.fields?.value) {
        const regEx = regExpFromSitecorePattern(formElements?.regex?.fields?.value?.value);
        const emailFieldValue = getValues(formElements.key.value);
        if (emailFieldValue === null || emailFieldValue === undefined) {
          return true;
        }
        const fieldValue = String(emailFieldValue);
        return regEx.test(fieldValue) ? true : formElements?.invalidInputMessage?.value;
      }
    },
  };
}
